import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

// bot wizard
export const useGenerateBotOpened = () =>
	useSendEvent(events.generator.generateBotOpened, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useGenerateBotRebuild = () =>
	useSendEvent(events.generator.generateBotRebuild);

export const useGenerateBotActivate = () =>
	useSendEvent(events.generator.generateBotActivate);

export const useGenerateBotActivateUsingNeurons = () =>
	useSendEvent(events.generator.generateBotActivateUsingNeurons);

export const useGenerateBotError = () =>
	useSendEvent(events.generator.generateBotError);

export const useGenerateBotSummary = () =>
	useSendEvent(events.generator.generateBotSummary, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useGenerateBotDescription = () =>
	useSendEvent(events.generator.generateBotDescriptionStep, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

// media
export const useGenerateImprovePrompt = (source: 'photo' | 'video') =>
	useSendEvent(events.generator.generateImprovePrompt, {
		source,
	});

// images
export const useGenerateImagesOpened = () =>
	useSendEvent(events.generator.generateImagesOpened, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useGenerateImagesPromptInfo = () =>
	useSendEvent(events.generator.generateImagesPromptInfo);

export const useGenerateImagesReuseParams = () =>
	useSendEvent(events.generator.generateImagesReuseParams);

export const useGenerateImagesAnimate = () =>
	useSendEvent(events.generator.generateImagesAnimate);

export const useGenerateImagesSubmitted = ({
	freeGenerations,
}: {
	freeGenerations: number;
}) =>
	useSendEvent(
		freeGenerations
			? events.generator.generateImagesSubmittedWithFree
			: events.generator.generateImagesSubmitted
	);

export const useGenerateImagesError = () =>
	useSendEvent(events.generator.generateImagesError);

export const useGenerateImagesDeleted = () =>
	useSendEvent(events.generator.generateImagesDeleted);

export const useGenerateImagesViewGallery = () =>
	useSendEvent(events.generator.generateImagesViewGallery);

export const useGenerateImagesDownloadImage = () =>
	useSendEvent(events.generator.generateImagesDownloadImage);

export const useGenerateImagesWithdrawNeurons = () =>
	useSendEvent(events.generator.generateImagesWithdrawNeurons);

export const useGenerateImagesBoughtSubscription = () =>
	useSendEvent(events.generator.generateImagesBoughtSubscription);

// video

export const useGenerateVideoOpened = () =>
	useSendEvent(events.generator.generateVideoOpened, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useGenerateVideoAnimateModalOpened = () =>
	useSendEvent(events.generator.generateVideoAnimateModalOpened);

export const useGenerateVideoDownloadVideo = () =>
	useSendEvent(events.generator.generateVideoDownloadVideo);

export const useGenerateVideoSubmitted = ({
	free,
	source = 'videogen',
}: {
	free: boolean;
	source?: 'videogen' | 'photogen_image_to_video' | 'chat_image_to_video';
}) =>
	useSendEvent(
		free
			? events.generator.generateVideoSubmittedWithFree
			: events.generator.generateVideoSubmitted,
		{
			source,
		}
	);

export const useGenerateVideoSurpriseMe = () =>
	useSendEvent(events.generator.generateVideoSurpriseMe);

export const useGenerateVideoSelectModel = () =>
	useSendEvent(events.generator.generateVideoSelectModel);

export const useGenerateVideoPickModel = () =>
	useSendEvent(events.generator.generateVideoPickModel);

export const useGenerateVideoSelectGender = () =>
	useSendEvent(events.generator.generateVideoSelectGender);

export const useGenerateVideoReuseParams = () =>
	useSendEvent(events.generator.generateVideoReuseParams);

export const useGenerateVideoError = ({
	source = 'videogen',
}: {
	source?: 'videogen' | 'photogen_image_to_video';
}) =>
	useSendEvent(events.generator.generateVideoError, {
		source,
	});

export const useGenerateVideoDeleted = () =>
	useSendEvent(events.generator.generateVideoDelete);

export const useGenerateVideoViewGallery = () =>
	useSendEvent(events.generator.generateVideoViewGallery);

export const useGenerateVideoAboutPrompt = () =>
	useSendEvent(events.generator.generateVideoAboutPrompt);
